export const getIconName = (isUnfolded = false, isMobile = false) => isMobile ? getMobileName(isUnfolded) : getDesktopName(isUnfolded);
const getDesktopName = (isUnfolded = false) => (isUnfolded ? 'MinusIcon' : 'PlusIcon');
const getMobileName = (isUnfolded = false) => isUnfolded ? 'ArrowUpSolidIcon' : 'ArrowDownSolidIcon';
//# sourceMappingURL=getIconName.js.map